import React, { useEffect } from 'react';
import { useDispatch } from 'react-redux';

import { OrdersPageGridHeaderWithOverflow as GridHeaderContainer } from './containers/grid-header-container';
import OrdersGridPresetsContainer from './containers/orders-grid-presets-container';
import { useIsOnOrdersAdvancedSearchView } from '../../advanced-search/hooks';
import { Coachmark } from '../../components/coachmark/components/coachmark';
import { ORDERS_PAGE_COACHMARKS } from '../../components/coachmark/steps';
import { OrdersFilterviewListContainer } from '../../components/filterview-list/orders-filterview-list-container';
import OpenOrderScanToSearchModalHotkey from '../../components/hotkeys/open-orders-scan-to-search-modal';
import { OrdersFilterBarContainer } from '../../containers/orders-filter-bar-container';
import { useQuickSearchTerm } from '../../hooks/routing/use-quick-search-term';
import { clearSelectedOrders } from '../../store/orders/selected-orders/orders.selected-orders.actions';
import style from '../grid-page.module.less';

const steps = {
  ORDERS_PAGE_COACHMARKS,
};

export const OrdersPage = () => {
  const dispatch = useDispatch();
  const isInAdvancedSearch = useIsOnOrdersAdvancedSearchView();
  const quickSearchTerm = useQuickSearchTerm();
  const isInQuickSearch = !!quickSearchTerm && !!quickSearchTerm.length;

  useEffect(() => {
    dispatch(clearSelectedOrders());
  }, [dispatch, quickSearchTerm]);

  return (
    <div className={style['main-content']}>
      <div className={style['grid-header']}>
        <GridHeaderContainer supportsNewOrder />
      </div>
      <div className={style['edit-grid-wrap']}>
        {!isInAdvancedSearch && !isInQuickSearch && <OrdersFilterviewListContainer />}
        <div className={style['grid-filter-wrap']}>
          <OrdersFilterBarContainer isInQuickSearch={isInQuickSearch} />
        </div>
      </div>
      <OrdersGridPresetsContainer />
      <OpenOrderScanToSearchModalHotkey />
      <Coachmark steps={steps.ORDERS_PAGE_COACHMARKS} />
    </div>
  );
};
